"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.directive("addPresentationButton", function($timeout, leafletPresentationButton) {
    return {
        restrict : "A",
        require : "obsLeafletMap",
        link : function($scope, $el, $attrs, mapCtrl) {

            var unwatch = $scope.$watch("mapConfig", function(mapConfig) {
                if(mapConfig != null) {
                    unwatch();
                    $timeout(function() {
                        addPresentationButton();
                    }, 1);
                }
            });

            var addPresentationButton = function() {
                mapCtrl.getMap().then(function(map) {
                    var watermark = new leafletPresentationButton();
                    map.addControl(watermark);
                });
            };

        }
    };
});


// WEBPACK FOOTER //
// ./src/apps/observatoire/ng/presentation/addPresentationButton.js